import React from "react";
import { connect } from "react-redux";
import { Dropdown } from "react-bootstrap";
import { FiPlus, FiMoreHorizontal, FiCheck } from "react-icons/fi";
import { showModal, hideModal } from "actions/modalActions";
import * as employeesActions from "actions/employeesActions";
import EmployeeUbicationEdit from "./EmployeeUbicationEditModal";
import UbicationEdit from "../Ubications/UbicationEditModal";
import DataTable from "components/DataTable";
import { employeesService } from "services";
import { errorFormating } from "utils/utils";
import { isAdmin } from "utils/utils";
import { withTranslation } from "react-i18next";

class EmployeeUbications extends React.Component {
	constructor(props) {
		super(props);
		//console.log(props);
		this.closeModal = this.closeModal.bind(this);
		this.openNewEmployeeUbicationModal =
			this.openNewEmployeeUbicationModal.bind(this);
		this.openEditEmployeeUbicationModal =
			this.openEditEmployeeUbicationModal.bind(this);
		this.openEditUbicationModal = this.openEditUbicationModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.getUbications = this.getUbications.bind(this);
	}

	componentDidMount() {
		this.getUbications();
	}

	async getUbications() {
		const employeeId = this.props.employee.id;
		await this.props.getEmployeeUbications(employeeId);
	}

	closeModal() {
		this.props.hideModal();
	}

	openNewEmployeeUbicationModal() {
		const { ubications, employee } = this.props;

		this.props.showModal(
			{
				open: true,
				title: this.props.t("ubications.assignment.assignUbication"),
				style: { width: "450px" },
				content: (
					<EmployeeUbicationEdit
						handleClose={this.closeModal}
						ubications={ubications}
						employee={employee}
						onDataChanged={this.props.onDataChanged}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openEditEmployeeUbicationModal(employee_ubication) {
		const { ubications, employee } = this.props;

		this.props.showModal(
			{
				open: true,
				title: this.props.t("ubications.assignment.editAssignment"),
				style: { width: "350px" },
				content: (
					<EmployeeUbicationEdit
						employee_ubication={employee_ubication}
						employee={employee}
						handleClose={this.closeModal}
						ubications={ubications}
						onDataChanged={this.props.onDataChanged}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openEditUbicationModal(employee_ubication) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("ubications.editUbication"),
				style: { width: "450px" },
				content: (
					<UbicationEdit
						ubication={employee_ubication.ubication}
						getUbications={this.getUbications}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openDeleteEmployeeUbicationModal(idUbication) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("ubications.assignment.deleteAssignment"),
				style: { width: "400px" },
				message:
					this.props.t("ubications.assignment.deleteConfirmation"),
				deleteAction: () => this.confirmDelete(idUbication),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	openAlertModal(message) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("ubications.assignment.deleteError"),
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	confirmDelete = async (idUbication) => {
		const response = await employeesService.removeUbication(
			this.props.employee.id,
			idUbication
		);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(textError.id);
		} else {
			this.getUbications();
			if (typeof this.props.onDataChanged === "function") {
				this.props.onDataChanged();
			}
			this.closeModal();
		}
	};

	getColumns = () => [
		{
			key: "ubication",
			header: this.props.t("ubications.assignment.headerName"),
			sortAccessor: (row) => row.ubication?.name || "",
			render: (row) => (
				<button className="btn-transparent btn-editable" onClick={() => this.openEditEmployeeUbicationModal(row)}>
					{row.ubication.name}
				</button>
			),
		},
		{
			key: "description",
			header: this.props.t("ubications.assignment.headerDescription"),
			sortAccessor: (row) => row.ubication?.description || "",
			render: (row) => row.ubication.description,
		},
		{
			key: "skill",
			header: this.props.t("ubications.assignment.headerSkill"),
			sortAccessor: (row) => row.skill && row.skill !== -1 ? row.skill : null,
			render: (row) => row.skill && row.skill !== -1 ? row.skill : "-",
		},
		{
			key: "default",
			header: this.props.t("ubications.assignment.headerDefault"),
			sortAccessor: (row) => row.is_default ? 1 : 0,
			render: (row) => row.is_default ? <FiCheck className="tick-default" /> : null,
		},
	];

	renderActions = (employee_ubication) => (
		<Dropdown>
			<Dropdown.Toggle variant="action"><FiMoreHorizontal /></Dropdown.Toggle>
			<Dropdown.Menu>
				<Dropdown.Item as="button" onClick={() => this.openEditEmployeeUbicationModal(employee_ubication)}>
					{this.props.t("ubications.assignment.editAssignmentAction")}
				</Dropdown.Item>
				{isAdmin() && (
					<Dropdown.Item as="button" onClick={() => this.openEditUbicationModal(employee_ubication)}>
						{this.props.t("ubications.assignment.editUbicationAction")}
					</Dropdown.Item>
				)}
				<Dropdown.Item as="button" onClick={() => this.openDeleteEmployeeUbicationModal(employee_ubication.id)}>
					{this.props.t("common.delete")}
				</Dropdown.Item>
			</Dropdown.Menu>
		</Dropdown>
	);

	render() {
		const { employee_ubications } = this.props;

		return (
			<div className="employee-profile-datatable-wrap">
				<DataTable
					tableClassName="table-groups table-employee-ubications table-hover"
					columns={this.getColumns()}
					rows={employee_ubications}
					rowKey={(row) => row.id}
					emptyMessage={this.props.t("ubications.assignment.noUbicationsAssigned")}
					actionsColumn={{
						render: this.renderActions,
						className: "td-actions",
						header: <button type="button" title={this.props.t("ubications.assignment.addUbication")} onClick={this.openNewEmployeeUbicationModal} className="btn btn-new"><FiPlus /></button>,
					}}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		employee_ubications: state.employeesReducer.employee_ubications,
		ubications: state.ubicationsReducer.ubications,
		user: state.authReducer.user,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getEmployeeUbications: (id) =>
		dispatch(employeesActions.getEmployeeUbications(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EmployeeUbications));
